/* unplugin-vue-components disabled */import { render } from "./BaseLogin.vue?vue&type=template&id=ddf8586a&scoped=true"
import script from "./BaseLogin.vue?vue&type=script&lang=js"
export * from "./BaseLogin.vue?vue&type=script&lang=js"

import "./BaseLogin.vue?vue&type=style&index=0&id=ddf8586a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf8586a"]])

export default __exports__